var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtraseat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fastseat"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D6BC8C",
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_1309_copy_2",
    fill: "#D6BC8C",
    points: "18.86 21 2 21 2 13 4.14 13 4.14 19 18.86 19 18.86 13 21 13 21 21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraseat);
export default __webpack_public_path__ + "static/media/extraseat.d35952c43f8bd4fa66c2868790535a4b.svg";
export { ForwardRef as ReactComponent };